export default __webpack_public_path__ + "static/media/roadtrip.725299f6.png";